module.exports = __webpack_public_path__ + "img/PM_9.75e899e9.svg";